export class Competitor {
  private cardinal: number;
  private id: string;
  private name: string;
  private form: string;

  constructor(config: {
    cardinal: number;
    id: string;
    name: string;
    form: string;
  }) {
    this.cardinal = config.cardinal;
    this.id = config.id;
    this.name = config.name;
    this.form = config.form;
  }

  public static createCompetitor(config: {
    cardinal: number;
    form: string;
    id: string;
    name: string;
  }) {
    return new Competitor(config);
  }

  public getCompetitor() {
    return {
      cardinal: this.cardinal,
      id: this.id,
      name: this.name,
      form: this.form,
    };
  }

  public getCardinal() {
    return this.cardinal;
  }

  public getId() {
    return this.id;
  }

  public getName() {
    return this.name;
  }


  public getForm() {
    return this.form;
  }
}
